import React from 'react';
import { Users, Music, Utensils, MapPin, Clock, Star } from 'lucide-react';
import { useSiteContent } from '../context/SiteContext';
import './Features.css';

const ICON_MAP = { Users, Music, Utensils, MapPin, Clock, Star };

const Features = () => {
  const { features } = useSiteContent();

  const items = features?.items || [
    { icon: 'Users', title: 'Bis zu 500 Gaeste', description: 'Grosszuegiger Saal' },
    { icon: 'Music', title: 'DJ & Soundanlage', description: 'Professionelle Technik' },
    { icon: 'Utensils', title: 'Individuelle Menus', description: 'Catering nach Wunsch' },
    { icon: 'MapPin', title: 'Zentrale Lage', description: 'Woerth am Main' },
    { icon: 'Clock', title: 'Flexible Buchung', description: 'Ganztaegig verfuegbar' },
    { icon: 'Star', title: 'Persoenliche Betreuung', description: 'Individuelle Planung' },
  ];

  return (
    <section className="features section-padding" id="vorteile" data-testid="features-section">
      <div className="container">
        <div className="features-header">
          <h2 className="heading-1 text-center">{features?.sectionTitle || 'Warum BD Event Location'}</h2>
          <p className="body-large text-center space-top-md">{features?.sectionDescription || ''}</p>
        </div>
        <div className="features-grid space-top-xxl">
          {items.map((feature, index) => {
            const IconComp = ICON_MAP[feature.icon] || Star;
            return (
              <div key={index} className="feature-card">
                <div className="feature-icon"><IconComp size={32} /></div>
                <h3 className="heading-3 space-top-md">{feature.title}</h3>
                <p className="body-regular space-top-sm">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
